import moment from 'moment'

export const ageFormatter = (dob: string): string => {
  const ageInYears = moment().diff(moment(dob).format('MM-DD-YYYY'), 'years')
  const ageInMonths = moment().diff(moment(dob).format('MM-DD-YYYY'), 'months')
  return ageInYears < 1 ? `${ageInMonths}mo` : `${ageInYears}`
}
